import React from 'react';
import { ui } from '../pages/OrdersSearch.styled';
import CreditCardOffOutlinedIcon from '@mui/icons-material/CreditCardOffOutlined';
import BlockOutlinedIcon from '@mui/icons-material/BlockOutlined';

export type BillingNoticeTooltipProps = {
    variant: 'missing-payment' | 'suspended';
    children: React.ReactElement;
};

export const BillingNoticeTooltip: React.FC<BillingNoticeTooltipProps> = ({ variant, children }) => {
    const content = variant === 'suspended' ? (
        <ui.NoticeContent>
            <ui.NoticeHeader>
                <BlockOutlinedIcon />
                Orders Temporarily Suspended
            </ui.NoticeHeader>
            <ui.NoticeBody>
                New test orders for this account have been temporarily suspended. To restore ordering, please check and update your billing information.
            </ui.NoticeBody>
            <ui.NoticeBody>
                <strong>To update billing:</strong> go to <strong>Home</strong>, then open the <strong>Payment Settings</strong> card and select <strong>Manage Stripe billing</strong>.
            </ui.NoticeBody>
            <ui.NoticeDivider />
            <ui.NoticeContact>
                Still experiencing issues after updating your billing information? Contact support at <a href="tel:18774675925">1-877-467-5925</a>.
            </ui.NoticeContact>
            <ui.NoticeFooter>Thank you,<br />The Spectrum and SimplyTEST Team</ui.NoticeFooter>
        </ui.NoticeContent>
    ) : (
        <ui.NoticeContent>
            <ui.NoticeHeader>
                <CreditCardOffOutlinedIcon />
                Billing Information Required
            </ui.NoticeHeader>
            <ui.NoticeBody>
                Portal billing is enabled, but your organization hasn't provided credit card or ACH billing information yet.
            </ui.NoticeBody>
            <ui.NoticeBody>
                <strong>To place new orders:</strong> your Organization Administrator must add or update payment information in the portal. If your organization doesn't have an Administrator designated, please contact us to set one up.
            </ui.NoticeBody>
            <ui.NoticeBody>
                <strong>To add billing info:</strong> go to <strong>Home</strong>, then open the <strong>Payment Settings</strong> card and select <strong>Manage Stripe billing</strong>.
            </ui.NoticeBody>
            <ui.NoticeDivider />
            <ui.NoticeContact>
                Need help? Contact your SimplyTest account manager, or reach us at <a href="tel:18774675925">1-877-467-5925</a> / <a href="mailto:billing@simplytest.com">billing@simplytest.com</a>.
            </ui.NoticeContact>
            <ui.NoticeFooter>Thank you,<br />The SimplyTest Team</ui.NoticeFooter>
        </ui.NoticeContent>
    );

    return (
        <ui.WideTooltip title={content} placement="top-start">
            {children}
        </ui.WideTooltip>
    );
};
